<script setup lang="ts">
defineProps<{
  label: string;
  items: readonly { id: string; title: string }[];
}>();
</script>

<template>
  <nav :aria-label="label">
    <ul class="grid gap-3 sm:grid-cols-3">
      <li
        v-for="item in items"
        :key="item.id"
      >
        <a
          :href="`#${item.id}`"
          class="flex min-h-12 items-center border-l-2 border-brand-600 bg-white px-4 py-3 font-semibold text-brand-700 hover:bg-brand-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-700"
        >{{ item.title }}</a>
      </li>
    </ul>
  </nav>
</template>